import {React, useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import {Edit, Delete} from '@mui/icons-material';
import PTSlabsConfiguration from '../forms/PTSlabsConfiguration';
import Progress from '../Progress'
import Popup from '../Popup';
import Notification from '../Notification';
import ConfirmDialog from '../ConfirmDialog';
import { useDispatch, useSelector } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';

let fetch_id = 0;
let delete_id = 0;
export default function PTSlabsTable() {



  const [openPopup, setOpenPopup] = useState(false);
  const [taxes, setTaxes] = useState([]);
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const [confirmDialog, setConfirmDialog] = useState({isOpen: false, title: '', subTitle: ''});
  const [loading, setLoading] = useState(true);
  const UPDATE_PT_SLABS_CONFIG = useSelector(state => state.updateTable.updatePTslabsConfig);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function getAllPTSlabs(){
    try {
      const taxes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/configure/pt-slab-configure/view-taxes`);
      setTaxes(taxes.data);
    } catch (e) {
      if(e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        },1000);
      }
    }
    setLoading(false);
  }

  useEffect(()=>{
    getAllPTSlabs();
  }, []);

  useEffect(()=>{
    if(UPDATE_PT_SLABS_CONFIG) {
      getAllPTSlabs();
      dispatch(updateTableActions.stopUpdatePTslabsConfig());
    }
  }, [UPDATE_PT_SLABS_CONFIG]);

  const handleDelete = async  (delete_id) => {
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false
      });
      try {
        const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/configure/pt-slab-configure/delete-tax/` + delete_id);
        if(res.status === 200) {
          setNotify({
            isOpen: true,
            message: 'Successfully Deleted!',
            type: 'error'
          });
          dispatch(updateTableActions.startUpdatePTslabsConfig());
        }
      } catch (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      }
  }

  return (
    <>
    { loading ? <Progress/> :
        <div>
      <table class="table">
          <thead class="table-dark">
            <tr>
              
              <th scope="col">From</th>
              <th scope="col">To</th>
              <th scope="col">Gender</th>
              <th scope="col">Amount</th>
              <th scope="col">Exception Month</th>
              <th scope="col">Exception Amount</th>
              <th class="table-dark"></th>
              <th class="table-dark"></th>

            </tr>
          </thead>
          <tbody>
            {taxes.map((tax , i) => {
              return (
                <>
                  <tr>
                    
                    <td>{tax.TaxFrom}</td>
                    <td>{tax.TaxTo}</td>
                    <td>{tax.Gender}</td>
                    <td>{tax.TaxAmount}</td>
                    <td>{tax.ExceptionMonth}</td>
                    <td>{tax.ExceptionAmount}</td>

                    <td><button type="button" class="btn btn-outline-primary btn-sm" onClick={() => {setOpenPopup(true); fetch_id=tax.TaxId;}} > <Edit/> Edit </button></td>
                    <td><button type="button" class="btn btn-outline-danger btn-sm" onClick={() => setConfirmDialog({
                        isOpen: true,
                        title: 'Are you sure to delete this record?',
                        subTitle: "You can't undo this operation",
                        onConfirm: () => {handleDelete(delete_id=tax.TaxId)}
                      })}
                    
                    > <Delete/> Delete </button></td>
                  </tr>
              </>
            )
          })}

          </tbody>
        </table>
        <Popup
        title="Edit PT Slab"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        >
          <PTSlabsConfiguration fetch_id={fetch_id} />
        </Popup>

      <Notification
        notify={notify}
        setNotify={setNotify} 
      />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog} 
      />


      </div>}
    </>
    

  );
}
